import React from "react";
import { type GameState, type Season, type ViewMode } from "../../vowGameLogic";
import GameTile from "./GameTile";

type GameTileGridProps = {
  gameState: GameState;
  selectedTiles: number[];
  onTileClick: (index: number) => void;
  canPerformActions: boolean;
  viewMode: ViewMode;
  selectedSeason: Season;
  selectedOverlayMax: number;
};

const GameTileGrid: React.FC<GameTileGridProps> = ({
  gameState,
  selectedTiles,
  onTileClick,
  canPerformActions,
  viewMode,
  selectedSeason,
  selectedOverlayMax,
}) => (
  <div className="grid grid-cols-4 gap-0 border-2 border-black" id="plateau">
    {gameState.plateau.map((tile, index) => (
      <GameTile
        key={tile.id}
        tile={tile}
        index={index}
        isSelected={selectedTiles.includes(index)}
        gameState={gameState}
        viewMode={viewMode}
        selectedSeason={selectedSeason}
        canPerformActions={canPerformActions}
        selectedOverlayMax={selectedOverlayMax}
        onTileClick={onTileClick}
      />
    ))}
  </div>
);

export default GameTileGrid;
